import { Box, Card, CardContent, Typography, Button, Grid, Tabs, Tab } from '@mui/material';
import { Download, Print } from '@mui/icons-material';
import { useState } from 'react';
import { estadosFinancieros } from '../billingData';

const FinancialStatements = () => {
  const [tab, setTab] = useState(0);
  const data = estadosFinancieros;

  return (
    <Box>
      {/* Header */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box>
          <Typography variant="h5" component="h1" gutterBottom>
            Estados Financieros
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Balance General y Estado de Resultados
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button variant="outlined" startIcon={<Print />}>
            Imprimir
          </Button>
          <Button variant="contained" startIcon={<Download />} color="primary">
            Exportar PDF
          </Button>
        </Box>
      </Box>

      {/* Tabs */}
      <Tabs value={tab} onChange={(e, v) => setTab(v)} sx={{ mb: 3 }}>
        <Tab label="Balance General" />
        <Tab label="Estado de Resultados" />
      </Tabs>

      {/* Balance General */}
      {tab === 0 && (
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Card sx={{ height: '100%' }}>
              <CardContent>
                <Typography variant="h6" gutterBottom sx={{ borderBottom: '2px solid #1976d2', pb: 1 }}>
                  ACTIVOS
                </Typography>
                
                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#1976d2' }}>
                    Activos Corrientes
                  </Typography>
                  <Box sx={{ pl: 2 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Typography>Caja y Bancos</Typography>
                      <Typography>$15,000.00</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Typography>Cuentas por Cobrar</Typography>
                      <Typography>8,565.00</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Typography>Inventario</Typography>
                      <Typography>18,435.00</Typography>
                    </Box>
                  </Box>
                </Box>

                <Box>
                  <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#1976d2' }}>
                    Activos No Corrientes
                  </Typography>
                  <Box sx={{ pl: 2 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Typography>Propiedad y Equipo</Typography>
                      <Typography>$45,000.00</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Typography>Depreciación Acumulada</Typography>
                      <Typography>(5,000.00)</Typography>
                    </Box>
                  </Box>
                </Box>

                <Box sx={{ mt: 2, pt: 2, borderTop: '2px solid #1976d2' }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', fontWeight: 700 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>TOTAL ACTIVOS</Typography>
                    <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>${data.balance.activos.total.toLocaleString()}</Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card sx={{ height: '100%' }}>
              <CardContent>
                <Typography variant="h6" gutterBottom sx={{ borderBottom: '2px solid #d32f2f', pb: 1 }}>
                  PASIVOS
                </Typography>
                
                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#d32f2f' }}>
                    Pasivos Corrientes
                  </Typography>
                  <Box sx={{ pl: 2 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Typography>Cuentas por Pagar</Typography>
                      <Typography>$18,825.00</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Typography>IVA por Pagar</Typography>
                      <Typography>6,175.00</Typography>
                    </Box>
                  </Box>
                </Box>

                <Box>
                  <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#d32f2f' }}>
                    Pasivos No Corrientes
                  </Typography>
                  <Box sx={{ pl: 2 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Typography>Préstamos Bancarios</Typography>
                      <Typography>$10,000.00</Typography>
                    </Box>
                  </Box>
                </Box>

                <Box sx={{ mt: 2, pt: 2, borderTop: '2px solid #d32f2f' }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', fontWeight: 700 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>TOTAL PASIVOS</Typography>
                    <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>${data.balance.pasivos.total.toLocaleString()}</Typography>
                  </Box>
                </Box>

                <Typography variant="h6" gutterBottom sx={{ mt: 4, borderBottom: '2px solid #388e3c', pb: 1 }}>
                  PATRIMONIO
                </Typography>
                
                <Box sx={{ pl: 2 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography>Capital Social</Typography>
                    <Typography>${data.balance.patrimonio.capital.toLocaleString()}</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography>Reservas</Typography>
                    <Typography>{data.balance.patrimonio.reservas.toLocaleString()}</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography>Resultados Acumulados</Typography>
                    <Typography>{data.balance.patrimonio.resultados.toLocaleString()}</Typography>
                  </Box>
                </Box>

                <Box sx={{ mt: 2, pt: 2, borderTop: '2px solid #388e3c' }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', fontWeight: 700 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>TOTAL PATRIMONIO</Typography>
                    <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>${data.balance.patrimonio.total.toLocaleString()}</Typography>
                  </Box>
                </Box>

                <Box sx={{ mt: 2, pt: 2, borderTop: '3px solid #000', backgroundColor: '#f5f5f5', p: 1 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', fontWeight: 700 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>PASIVO + PATRIMONIO</Typography>
                    <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>${(data.balance.pasivos.total + data.balance.patrimonio.total).toLocaleString()}</Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      )}

      {/* Estado de Resultados */}
      {tab === 1 && (
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom sx={{ borderBottom: '2px solid #7b1fa2', pb: 1 }}>
              ESTADO DE RESULTADOS
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              Del 1 de Enero al 31 de Diciembre de 2025
            </Typography>

            <Box sx={{ pl: 2 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                <Typography sx={{ fontWeight: 500 }}>Ventas Netas</Typography>
                <Typography>${data.estadoResultados.ventas.toLocaleString()}</Typography>
              </Box>
              
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1, color: 'error.main' }}>
                <Typography>(-) Costo de Ventas</Typography>
                <Typography>(${data.estadoResultados.costoVentas.toLocaleString()})</Typography>
              </Box>
              
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2, pt: 1, borderTop: '1px solid #ccc', fontWeight: 600 }}>
                <Typography sx={{ fontWeight: 700 }}>UTILIDAD BRUTA</Typography>
                <Typography sx={{ fontWeight: 700 }}>${data.estadoResultados.utilidadBruta.toLocaleString()}</Typography>
              </Box>

              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1, color: 'error.main' }}>
                <Typography>(-) Gastos de Operación</Typography>
                <Typography>(${data.estadoResultados.gastosOperacion.toLocaleString()})</Typography>
              </Box>

              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2, pt: 1, borderTop: '1px solid #ccc', fontWeight: 600 }}>
                <Typography sx={{ fontWeight: 700 }}>UTILIDAD DE OPERACIÓN</Typography>
                <Typography sx={{ fontWeight: 700 }}>${data.estadoResultados.utilidadOperacion.toLocaleString()}</Typography>
              </Box>

              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1, color: 'error.main' }}>
                <Typography>(-) Otros Gastos</Typography>
                <Typography>(${data.estadoResultados.otrosGastos.toLocaleString()})</Typography>
              </Box>

              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1, pt: 1, borderTop: '1px solid #ccc' }}>
                <Typography sx={{ fontWeight: 500 }}>UTILIDAD ANTES DE IMPUESTOS</Typography>
                <Typography sx={{ fontWeight: 500 }}>${data.estadoResultados.utilidadAntesImpuestos.toLocaleString()}</Typography>
              </Box>

              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1, color: 'error.main' }}>
                <Typography>(-) Impuesto sobre la Renta (25%)</Typography>
                <Typography>(${data.estadoResultados.impuestos.toLocaleString()})</Typography>
              </Box>

              <Box sx={{ mt: 2, pt: 2, borderTop: '3px solid #7b1fa2', backgroundColor: '#f3e5f5', p: 1 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', fontWeight: 700 }}>
                  <Typography variant="h6" sx={{ fontWeight: 700 }}>UTILIDAD NETA</Typography>
                  <Typography variant="h6" sx={{ fontWeight: 700 }}>${data.estadoResultados.utilidadNeta.toLocaleString()}</Typography>
                </Box>
              </Box>
            </Box>
          </CardContent>
        </Card>
      )}
    </Box>
  );
};

export default FinancialStatements;
